module.exports = __webpack_public_path__ + "static/img/oilba.868b6f2b.png";